import create from 'zustand';

const useAddressStore = create((set) => ({
  address: '',
  setAddress: (address) => set({ address }),
  clearAddress: () => set({ address: '' }),
}));

export default useAddressStore;
